import React from 'react';

import {APP} from "../../../core/app/consts";
import {observer} from "mobx-react";
import {ACTION_TYPES} from "../../../core/consts";
import {PartialGameViewModel} from "../../../domain/partial-game/models/partial-game-view-model";
import {Prediction} from "../../../core/components/prediction/components/prediction";

export const PredictionWidgetCard = observer(({controller, card, index, betsImpressionParams, onBookieClick}) => {
  const {state} = controller;
  const {
    gameId,
    competitionId,
    statusGroup,
    currentContext,
    showOdds,
    currentLinkModel,
    date,
    isContextualMode,
    isContextualUsed,
    isPropsTabsVisible,
    selectedTab
  } = state;

  const {currentIndex} = currentContext;
  const {id, options, type, hasOdds, hasInsight} = card;
  const isVisible: Boolean = currentIndex === index;

  const onVoteClick = (option) => {
    controller.action(ACTION_TYPES.predictionClickEvent, {
      date,
      gameId,
      hasOdds,
      subSource: isPropsTabsVisible ? APP.ANALYTICS.SOURCES.propositionBets : APP.ANALYTICS.SOURCES.predictions,
      hasInsight,
      competitionId,
      num: option.num,
      key: option.vote.key,
      predictionId: id,
      status: statusGroup,
      currentLinkModelName: currentLinkModel.name,
      selectionsCount: options.length,
      marketType: type,
      isContextual: isContextualMode,
      contextualUsed: isContextualUsed,
      source: APP.ANALYTICS.SOURCES.predictions,
      prediction: card
    });
  }

  const showPrediction = () => controller.action(ACTION_TYPES.predictionShow, {
    entityType: APP.ANALYTICS.ENTITY_DISPLAY_TYPES[PartialGameViewModel.name] || null,
    screen: APP.ANALYTICS.SCREENS[currentLinkModel?.name],
    screenId: currentLinkModel?.params.id || null,
    status: statusGroup,
    isContextual: isContextualMode,
    contextualUsed: isContextualUsed,
    tabName: selectedTab?.analyticsLabel
  });

  const predictionProps = {
    prediction: card,
    showOdds,
    isVisible,
    controller,
    onVoteClick,
    showPrediction,
    betsImpressionParams,
  }

  return <Prediction {...predictionProps}/>
});